<template>
  <div class="sheet-page">
     <KeySet :column="column" :button="button" :LanguageSet="3" :api="'sheetsConfig'" :comDataId="dataId" @handleClickHandle="handleClickHandle" />
     <el-dialog :title="title" :visible.sync="dialogVisible" width="50%" append-to-body :fullscreen="true">
      <languageSet v-if="title === '语言设置'" :dataIdFour="tableDataId" :typeFour="tableDataType"></languageSet>
      <codingSet v-if="title === '编码设置'" :codingSetData="codingSetData"></codingSet>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KeySet from "../com/index";
import languageSet from '../LanguageSet/index.vue'
import codingSet from '../codingSet/index.vue'
export default {
  name: 'sheetPage',
  components: { KeySet, languageSet, codingSet },
  props: {
    dataIdFive: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      column: [
        { prop: "sheetName", label: this.$t('SheetSetting.name'),alignType: 2 },
        { prop: "showOrder", label: this.$t('SheetSetting.AccordingToTheOrder'),alignType: 2 },
      ],
      button: [{ key: "add", label: this.$t('SheetSetting.add') }],
      dataId: '',
      dialogVisible: false,
      title: '',
      tableDataId: '',
      tableDataType: '',
      codingSetData: {}
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {
    dataIdFive: {
      handler(newVal, oldVal) {
        this.dataId = newVal
      }, deep: true, immediate: true
    }
  },
  methods: {
    handleClickHandle(title, row, LanguageSet) {
      switch (title) {
        case "Language":
          this.title = '语言设置'
          this.dialogVisible = true
          this.tableDataId = row.id
          this.tableDataType = LanguageSet
          break;
        case 'coding':
          this.title = '编码设置'
          this.dialogVisible = true
          this.codingSetData = row
          break;
      }
    }
  },
  
};
</script>

<style scoped lang="scss">
.sheet-page{
  height: 100%;
}
</style>
